<template>
    <el-drawer
        :before-close="cancel"
        :title="`${detail.name}`"
        :visible.sync="dialogVisible"
        :wrapperClosable="true"
        center
        class="dialog-container flex flex-direction"
        direction="rtl"
        size="700px">
        <div class="dialog-content flex flex-direction padding-lr-sm flex-sub">
            <div class="flex flex-direction flex-sub" v-if="detail">
                <div class="flex align-center justify-between">
                    <div class="text-black text-df"><i class="iconfont icon-vertical_line text-black text-bold text-dfs"></i>{{ detail.p_name }}</div>
                    <div class="flex align-center">
                        <div class="text-xs margin-right-xs">优先级</div>
                        <el-tag :type="detail.level | level_color" class="task-tag radius">{{ detail.level | level }}
                        </el-tag>
                    </div>
                </div>
                <div v-if="detail.state === 5 || detail.state === 9" class="bg-red padding-sm radius margin-top-sm text-sm text-white">
                    拒绝原因：<span class="text-bold">{{ detail.reason }}</span>
                </div>
                <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="publish-form  padding-sm radius margin-top-sm" labelWidth="auto">
                    <el-form-item label="负责人" prop="t_mid">
                        <div>{{ detail.fuzeren }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="成员" prop="join_mid_str">
                        <div>{{ detail.join_mid }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="分值" prop="join_mid_str">
                        <div>{{ detail.is_outside ? '--' : (detail.score || '--') }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="时间" prop="end_time">
                        <div>{{ detail.end_time }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="描述" prop="desc">
                        <div>{{ detail.desc || '--' }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.file.length" class="document" label="附件" prop="file">
                        <div class="flex margin-bottom-sm">
                            <div class="flex-sub flex flex-direction">
                                <div v-for="(item,index) in detail.file" :key="index" class="flex align-center">
                                    <div :href="item.url" class="file-name flex-sub ovHide text-sm" target="_blank" @click="toFilePreview(item.name,item.url)">
                                        <i class="el-icon-tickets margin-right-xs"></i>{{ item.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.folder.length" label="需求佐证" prop="file">
                        <div class="flex margin-bottom-sm">
                            <div class="flex-sub flex flex-direction">
                                <div v-for="(item,index) in detail.folder" :key="index" class="flex align-center justify-between">
                                    <div class="flex-sub ovHide cursor" @click="addFile(item)">
                                        <i class="iconfont icon-24gf-folderOpen margin-right-xs"></i>{{ item.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.finish_time" label="实际完成时间" prop="finish_time">
                        <div>{{ detail.finish_time }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.self_assessment_score" label="自评得分" prop="self_assessment_score">
                        <div>{{ detail.self_assessment_score }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.self_assessment" label="自评说明" prop="self_assessment">
                        <div>{{ detail.self_assessment }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.assessment_score" label="评审得分" prop="self_assessment_score">
                        <div>{{ detail.assessment_score }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.assessment" label="评审意见" prop="self_assessment">
                        <div>{{ detail.assessment }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                </el-form>
                <div class="publish-form flex flex-direction padding-lr-sm padding-tb-xs radius margin-top-sm">
                    <div class="flex align-center justify-between">
                        <div class="text-black text-bold text-lg">任务动态</div>
                        <el-button type="text"><i class="el-icon-arrow-down text-df"></i></el-button>
                    </div>
                    <div v-for="(item,index) in detail.task_dynamic" :key="index" class="flex align-center justify-between margin-top-xs ">
                        <div class="title text-xs text-black padding-lr-sm">
                            <span>{{ item.member_name }}</span>{{ item.change_content }}
                        </div>
                        <div class="text-xs text-black">{{ item.create_time }}</div>
                    </div>
                </div>
            </div>
            <div class="foot-view"></div>
            <div v-if="is_edit_task" class="foot flex align-center justify-around">
                <el-button class="btn max radius" type="danger" @click="changeInfo(0)">信息修改</el-button>
                <el-button class="btn max radius" type="primary" @click="changeInfo(1)">任务变更</el-button>
            </div>
        </div>
        <task-add-task-dialog :add_state="add_state" :dialog-visible="addTaskDialog" :pid="detail.proid" :pname="detail.p_name" :sid="detail.pid" :tid="tid" @watchState="watchState"></task-add-task-dialog>
        <task-folder-dialog :dialog-visible="addFileDialog" :readonly="!detail.is_operation" :fid="cur_fid" :fname="cur_fname" :pname="detail.p_name" :tname="detail.name" @watchState="watchState"></task-folder-dialog>
    </el-drawer>
</template>

<script>
import {getTaskDetail} from "@/api";
import {is_task_edit, level_color, levels} from "@/utils/const";
import TaskAddTaskDialog from "@/views/web/staff/components/TaskAddTaskDialog";
import TaskFolderDialog from "@/views/web/staff/components/TaskFolderDialog";
import {toFilePreview} from "@/utils/utils";

export default {
    name: "TaskDetailTaskDialog",
    components: {TaskFolderDialog, TaskAddTaskDialog},
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        tid: { //任务id
            type: Number,
        },
        readonly: { //是否可以修改任务信息
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            ruleForm: {
                name: '',
                level: '',
                t_mid: '',
                join_mid_str: [],
                end_time: '',
                desc: '',
                recommend: '',
                file: [],
                folder_ids: [],
            },
            detail: '',
            rules: {
                name: [
                    {required: true, message: '请输入任务名称', trigger: 'blur'}
                ],
                level: [
                    {required: true, message: '请选择优先级', trigger: 'change'},
                ],
                t_mid: [
                    {required: true, message: '请选择负责人', trigger: 'change'},
                ],
                join_mid_str: [
                    {required: true, message: '请选择成员', trigger: 'change'},
                ],
                end_time: [
                    {required: true, message: '请选择时间', trigger: 'blur'}
                ],
            },
            addTaskDialog: false,
            add_state: 0,
            is_edit_task: false,
            addFileDialog: false,
            cur_fname: '',
            cur_fid: 0
        }
    },
    created() {
        this.setData()
    },
    methods: {
        changeInfo(state) {
            this.add_state = state
            this.addTaskDialog = true
        },
        addFile(data) {
            this.cur_fname = data.name
            this.cur_fid = data.id
            this.addFileDialog = true
        },
        watchState(data) {
            if (data) {
                switch (data.type) {
                    case 'task' :
                        this.setData()
                        this.$emit('watchDetailState', true)
                        break
                }
            }
            this.cur_fid = 0
            this.addTaskDialog = false
            this.addFileDialog = false
        },
        cancel() {
            this.is_edit_task = false
            this.$emit('watchDetailState', false)
        },
        async setData() {
            if (this.tid) {
                let _data = await getTaskDetail(this.tid)
                _data.data.file = _data.data.file ? JSON.parse(_data.data.file) : []
                this.detail = _data.data
                this.is_edit_task = !this.readonly && _data.data.is_operation && is_task_edit(_data.data.state)
            }
        },
        toFilePreview(name,url){
            toFilePreview(name,url)
        }
    },
    filters: {
        level(val) {
            return levels.find(f => Number(f.value) === val).label
        },
        level_color(val) {
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            return level_color(val)
        },
    },
    watch: {
        tid() {
            this.setData()
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog-container {
    .publish-form {
        border: solid 1px #e6e6e6;

        .title {
            position: relative;

            &::before {
                position: absolute;
                content: '';
                width: 9px;
                height: 9px;
                border-radius: 9px;
                background-color: var(--blue);
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
}

</style>